module.exports = __webpack_public_path__ + "static/media/sprite_ring-text-range.85175490.svg";